export const REQUEST_MASTER_SLOTS = "REQUEST_MASTER_SLOTS";
export const SET_MASTER_SLOTS = "SET_MASTER_SLOTS";
export const ERROR_GET_MASTER_SLOTS = "ERROR_GET_MASTER_SLOTS";

export const REQUEST_CREATE_GET_MASTER_SLOTS =
  "REQUEST_CREATE_GET_MASTER_SLOTS";
export const SUCCESS_CREATE_GET_MASTER_SLOTS =
  "SUCCESS_CREATE_GET_MASTER_SLOTS";
export const ERROR_CREATE_GET_MASTER_SLOTS = "ERROR_CREATE_GET_MASTER_SLOTS";

export const REQUEST_CREATE_MASTER_SLOTS = "REQUEST_CREATE_MASTER_SLOTS";
export const SUCCESS_CREATE_MASTER_SLOTS = "SUCCESS_CREATE_MASTER_SLOTS";
export const ERROR_CREATE_MASTER_SLOTS = "ERROR_CREATE_MASTER_SLOTS";

export const REQUEST_UPDATE_MASTER_SLOTS = "REQUEST_UPDATE_MASTER_SLOTS";
export const SUCCESS_UPDATE_MASTER_SLOTS = "SUCCESS_UPDATE_MASTER_SLOTS";
export const ERROR_UPDATE_MASTER_SLOTS = "ERROR_UPDATE_MASTER_SLOTS";

export const REQUEST_DELETE_MASTER_SLOTS = "REQUEST_DELETE_MASTER_SLOTS";
export const SUCCESS_DELETE_MASTER_SLOTS = "SUCCESS_DELETE_MASTER_SLOTS";
export const ERROR_DELETE_MASTER_SLOTS = "ERROR_DELETE_MASTER_SLOTS";

export const SET_MESSAGE_MASTER_SLOTS = "SET_MESSAGE_MASTER_SLOTS";
